/**
 * Iatrode.UI - Avatar & Boring Avatar Integration
 * 整合 ui.avatar.js 和 boring-avatars 库
 * 
 * 此脚本需要在 ui.avatar.js 之后加载
 */

(function($) {
    'use strict';

    // 在 DOM 加载完成后，渲染所有带有 boring-avatar 数据属性的头像
    $(document).ready(function() {
        // 延迟一点执行渲染，确保 DOM 完全加载
        setTimeout(function() {
            renderBoringAvatars();
        }, 100);
    });

    // 监听 ui.avatar 渲染完成事件
    $(document).on('avatar.rendered', '[data-boring-avatar]', function() {
        renderBoringAvatar($(this));
    });

    /**
     * 渲染所有 Boring Avatar
     */
    function renderBoringAvatars() {
        $('[data-boring-avatar="true"][data-auto-render="true"]').each(function() {
            renderBoringAvatar($(this));
        });
    }

    function getDropdownCore() {
        return window.IatrodeUI && window.IatrodeUI.dropdown ? window.IatrodeUI.dropdown : null;
    }

    function isMenuOpen($menu) {
        if (!$menu || !$menu.length) return false;
        return $menu.hasClass('show') && $menu.css('visibility') !== 'hidden';
    }

    function closeAllStandaloneAvatarDropdowns(exceptId) {
        $('.dropdown-menu.ui-avatar-dropdown[data-avatar-standalone]').each(function() {
            const $menu = $(this);
            if (exceptId && $menu.attr('data-avatar-standalone') === exceptId) {
                return;
            }

            const core = getDropdownCore();
            if (core) {
                core.hide($menu[0]);
            } else {
                $menu.removeClass('show').css({
                    display: 'none',
                    visibility: 'hidden',
                    opacity: 0,
                    transform: 'translateY(-10px)'
                });
            }
        });
    }

    /**
     * UI 增强：为 Boring Avatar 添加交互和样式
     * 不破坏 boring-avatars.js 已经渲染的 SVG
     */
    function renderBoringAvatar($element) {
        // 检查是否已经 UI 增强过
        if ($element.data('ui-enhanced')) {
            return;
        }

        // 检查是否有 data-boring-avatar 属性
        if ($element.data('boring-avatar') !== true && $element.data('boring-avatar') !== 'true') {
            return;
        }

        // 等待 boring-avatars.js 渲染完成（检查 data-rendered 属性）
        if (!$element.attr('data-rendered')) {
            // SVG 还没渲染，稍后重试
            setTimeout(function() {
                renderBoringAvatar($element);
            }, 50);
            return;
        }

        // 提取配置
        const size = parseInt($element.data('size')) || 40;
        const square = $element.data('square') === 'true' || $element.data('square') === true;

        // 检查是否有下拉菜单（通过 dropdown 类判断，因为 boring-avatars.js 渲染后会添加回来）
        const hasDropdown = $element.hasClass('dropdown');
        const managedByUiAvatar = !!$element.data('ui.avatar.instance');
        const $dropdownMenu = $element.find('.dropdown-menu');

        // 添加 UI 增强的 CSS 类
        $element.addClass('boring-avatar-enhanced');
        
        // 为 SVG 添加容器类（不破坏 SVG，只包装样式）
        const $svg = $element.find('> svg');
        if ($svg.length > 0) {
            $svg.wrap('<div class="boring-avatar-svg-wrapper ui-avatar-img"></div>');
            const $wrapper = $svg.parent();
            
            const borderRadius = square ? '8px' : '50%';
            
            // 应用样式
            $wrapper.css({
                width: size + 'px',
                height: size + 'px',
                display: 'block',
                position: 'relative',
                borderRadius: borderRadius,
                overflow: 'hidden',  // 只裁剪 SVG，不影响下拉菜单
                cursor: hasDropdown ? 'pointer' : 'default',
                flexShrink: '0',
                zIndex: '1'  // wrapper 在底层
            });
            
            // SVG 本身也需要圆角
            $svg.css({
                display: 'block',
                width: '100%',
                height: '100%',
                borderRadius: borderRadius
            });
            
            // 确保容器支持绝对定位的子元素，并允许内容溢出
            $element.css({
                display: 'inline-block',  // 重要：不能是 flex，否则影响下拉菜单定位
                position: 'relative',
                overflow: 'visible',  // 关键：允许下拉菜单溢出！
                verticalAlign: 'middle'  // 与其他内联元素对齐
            });
            
            // 让下拉菜单统一使用 Avatar 组件主题样式（与 select hover 视觉一致）
            if (hasDropdown && $dropdownMenu.length > 0 && managedByUiAvatar) {
                $dropdownMenu.addClass('ui-avatar-dropdown ui-avatar-dropdown-select-like');
                setupUiAvatarBridge($element, $wrapper);
            }

            if (hasDropdown && $dropdownMenu.length > 0 && !managedByUiAvatar) {
                $dropdownMenu.addClass('ui-avatar-dropdown ui-avatar-dropdown-select-like');
                // 设置下拉菜单交互
                setupDropdownInteraction($element, $wrapper, $dropdownMenu);
            }
        }
        
        $element.data('ui-enhanced', true);
    }

    /**
     * 设置下拉菜单交互
     */
    function setupDropdownInteraction($element, $avatarContent, $dropdownMenu) {
        // 生成唯一的命名空间
        const namespace = 'boring-avatar-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        const standaloneId = 'boring-menu-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        const viewportMargin = 16;
        const offset = 8;
        let resizeTimer = null;

        $dropdownMenu.attr('data-avatar-standalone', standaloneId);

        // 由此脚本独占触发，避免与 bootstrap dropdown 行为竞争
        $element.removeAttr('data-bs-toggle');

        const positionDropdown = function(anchorRect) {
            if (!$dropdownMenu.length) {
                return;
            }

            const avatarEl = $avatarContent.get(0) || $element.get(0);
            const menuEl = $dropdownMenu.get(0);
            if (!avatarEl || !menuEl) {
                return;
            }

            const core = getDropdownCore();
            if (core) {
                core.place(menuEl, anchorRect || avatarEl, {
                    placement: 'auto',
                    offset: offset,
                    viewportMargin: viewportMargin,
                    appendToBody: true,
                    visible: true,
                    preferEndOnRight: true
                });
                return;
            }
        };
        
        // 点击头像切换菜单
        const onToggle = function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const isOpen = isMenuOpen($dropdownMenu);

            closeAllStandaloneAvatarDropdowns(standaloneId);
            
            if (!isOpen) {
                positionDropdown((e.currentTarget || $avatarContent.get(0)).getBoundingClientRect());
                const core = getDropdownCore();
                if (core) {
                    core.show($dropdownMenu[0]);
                } else {
                    $dropdownMenu.addClass('show').css('display', 'block');
                }
            } else {
                const core = getDropdownCore();
                if (core) {
                    core.hide($dropdownMenu[0]);
                } else {
                    $dropdownMenu.removeClass('show').css({
                        display: 'none',
                        visibility: 'hidden',
                        opacity: 0,
                        transform: 'translateY(-10px)'
                    });
                }
            }
        };

        // 点到 wrapper 或容器都能触发，避免命中区域不一致
        $avatarContent.on('click.' + namespace, onToggle);
        $element.on('click.' + namespace, onToggle);

        // 点击文档其他地方关闭菜单（使用命名空间）
        $(document).on('click.' + namespace, function(e) {
            if (!$(e.target).closest($element).length && !$(e.target).closest($dropdownMenu[0]).length) {
                const core = getDropdownCore();
                if (core) {
                    core.hide($dropdownMenu[0]);
                } else {
                    $dropdownMenu.removeClass('show').css({
                        display: 'none',
                        visibility: 'hidden',
                        opacity: 0,
                        transform: 'translateY(-10px)'
                    });
                }
            }
        });

        // 视口变化时保持在可见区域内
        $(window).on('resize.' + namespace + ' orientationchange.' + namespace, function() {
            if (isMenuOpen($dropdownMenu)) {
                window.clearTimeout(resizeTimer);
                resizeTimer = window.setTimeout(function() {
                    positionDropdown();
                }, 120);
            }
        });

        $(window).on('scroll.' + namespace, function() {
            if (isMenuOpen($dropdownMenu)) {
                positionDropdown();
            }
        });

        // 点击菜单项后关闭菜单（但允许链接跳转）
        $dropdownMenu.on('click.' + namespace, '.dropdown-item', function(e) {
            // 如果是链接，让浏览器处理跳转
            if ($(this).is('a[href]')) {
                setTimeout(function() {
                    const core = getDropdownCore();
                    if (core) {
                        core.hide($dropdownMenu[0]);
                    } else {
                        $dropdownMenu.removeClass('show').css({
                            display: 'none',
                            visibility: 'hidden',
                            opacity: 0,
                            transform: 'translateY(-10px)'
                        });
                    }
                }, 100);
            } else {
                const core = getDropdownCore();
                if (core) {
                    core.hide($dropdownMenu[0]);
                } else {
                    $dropdownMenu.removeClass('show').css({
                        display: 'none',
                        visibility: 'hidden',
                        opacity: 0,
                        transform: 'translateY(-10px)'
                    });
                }
            }
        });
        
        // 保存命名空间，以便后续可以解绑
        $element.data('_dropdown-namespace', namespace);
    }

    /**
     * 当头像由 ui.avatar 管理时，boring wrapper 仅做点击桥接
     */
    function setupUiAvatarBridge($element, $avatarContent) {
        const namespace = 'boring-avatar-bridge-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);

        $avatarContent.on('click.' + namespace, function(e) {
            e.preventDefault();
            e.stopPropagation();

            const instance = $element.data('ui.avatar.instance');
            if (instance && typeof instance.toggle === 'function') {
                instance.toggle();
                return;
            }

            const $img = $element.find('.ui-avatar-img').first();
            if ($img.length) {
                $img.trigger('click');
            }
        });

        $element.data('_avatar-bridge-namespace', namespace);
    }



    // 暴露全局方法
    window.IatrodeUI = window.IatrodeUI || {};
    window.IatrodeUI.renderBoringAvatars = renderBoringAvatars;
    window.IatrodeUI.renderBoringAvatar = renderBoringAvatar;

})(jQuery);
